<template>
  <a-card>
    <div>
      <a-page-header
        style="border: 1px solid rgb(235, 237, 240)"
        title="模板"
        @back="handleGoBack"
      >
      </a-page-header>
      <a-row>
        <a-col span="12">
          <a-form :model="form">
            <a-form-item label="模版名称" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input
                allow-clear
                v-decorator="[
                  'name',
                  {
                    rules: [
                      { required: true, message: '请输入' },
                    ],
                  },
                ]"
                placeholder="请输入" />
            </a-form-item>
            <a-form-item label="关键词占位符" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-button style="margin-left: 15px" @click="insert(item.en_name)" v-for="item in $Dictionaries.trade_contract_template_placeholders" :key="item.name">{{ item.name }}</a-button>
            </a-form-item>
            <a-form-item label="模版内容" :label-col="labelCol" :wrapper-col="wrapperCol">
              <div>
                <quill-editor
                  v-model="content"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                  @change="onEditorChange($event)">
                </quill-editor>
              </div>
            </a-form-item>
            <a-form-item v-bind="buttonCol">
              <a-row>
                <a-col span="6" :offset="6">
                  <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
                </a-col>
                <a-col span="10">
                  <a-button @click="handleGoBack">返回</a-button>
                </a-col>
                <a-col span="8"></a-col>
              </a-row>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import {
  trade_custom_reminder_template_read,
  trade_custom_reminder_template_list,
  trade_custom_reminder_rule_update
} from '@/api/trade_custom_reminder'
import pick from 'lodash.pick'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import { Quill } from 'vue-quill-editor/dist/ssr'
const fields = ['name', 'type', 'postpone_days', 'postpone_days_type', 'is_enabled', 'template_id']
const fonts = [ 'Sans-Serif', 'SimSun', 'FangSong', 'Serif', 'Monospace' ] // , 'SimHei', 'Microsoft-YaHei', 'KaiTi'
Quill.imports['formats/font'].whitelist = fonts
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  components: {
    quillEditor
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],

            [{ 'header': 1 }, { 'header': 2 }], // custom button values
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
            [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
            [{ 'direction': 'rtl' }], // text direction

            [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
            [{ 'font': fonts }],
            [{ 'align': [] }],

            ['clean'] // remove formatting button
          ],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          }
        }
      },
      content: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      trade_custom_reminder_template_list({ id: this.$route.params.id })
        .then(({ data }) => {
          console.log(data, '我是数据列表@')
          const entries = data.entries
          if (entries && entries.length > 0) {
            this.loadEditInfo(entries[0])
          }
        })
    })
  },
  methods: {
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    onEditorBlur (quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady (quill) {
      console.log('editor ready!', quill)
    },
    onEditorChange ({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.$emit('change', html)
    },
    insert (value) {
      const quill = this.$refs.myQuillEditor.quill
      const length = this.$refs.myQuillEditor.quill.selection.savedRange.index
      const data = '{' + value + '}'
      quill.insertEmbed(length, data)
      quill.setSelection(length + data.length)
    },
    loadEditInfo (data) {
      const formData = pick(data, fields)
      this.form.setFieldsValue(formData)
      trade_custom_reminder_template_read(data.id).then(({ data }) => {
       console.log(data, '我是模板')
        this.content = data.content
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          values['content'] = this.content
          trade_custom_reminder_rule_update(values, this.$route.params.id).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
              console.log(res, '修改成功')
            }
          })
        }
      })
    }
  }
}
</script>

<style>
@import "../../../../../assets/font/font.css";
.ql-container{
  height: 300px;
}
</style>
